import React from 'react';
import { Chip } from '@material-ui/core';

interface StatusChipProps {
  isActive: boolean;
}

const StatusChip: React.FC<StatusChipProps> = ({ isActive }) => {
  return (
    <Chip
      label={isActive ? 'Active' : 'Inactive'}
      size="small"
      style={{
        backgroundColor: isActive ? '#4caf50' : '#9e9e9e',
        color: 'white'
      }}
    />
  );
};

export default React.memo(StatusChip);
